<template>
  <div class="journey-detail-edit-test">
    <!-- Add your test content here -->
    <div v-if="init">
      <div class="row">
        <div class="col-6">
          <JourneyEditContainer
            :journey="journey"
            @updateJourneyObjectArray="updateJourneyObjectArray"
            ref="edit-main"/>
        </div>
        <div class="col-6">
          <b-card class="mb-4">
            <b-card-title>
              設定整個行程的出發時間
            </b-card-title>
            <b-card-body>
              <input type="datetime-local" v-model="startTimeValue">
              <button @click="setStartTime">設定出發時間</button>
            </b-card-body>
          </b-card>

          <b-card class="mb-4">
            <b-card-title>
              設定留宿點
            </b-card-title>
            <b-card-body>
              <select v-model="setRestPointIndex">
                <option v-for="(item, index) in milestoneAry" :key="`${item.name}-${index}`" :value="item.index">{{ item.index }}: {{ item.name }}</option>
              </select>
              <button @click="toggleRestPoint">設定/取消住宿點</button>
            </b-card-body>
          </b-card>

          <b-card class="mb-4">
            <b-card-title>
              設定留宿點出發時間
            </b-card-title>
            <b-card-body>
              <select v-model="setLeaveTimeIndex">
                <option v-for="(item, index) in restPointAry" :key="`${item.name}-${index}`" :value="item.index">{{ item.index }}: {{ item.name }}</option>
              </select>
              <input type="datetime-local" v-model="leaveTimeValue">
              <button @click="setLeaveTime">設定出發時間</button>
            </b-card-body>
          </b-card>

          <b-card class="mb-4">
            <b-card-title>
              設定爬升速度
            </b-card-title>
            <b-card-body>
              <select v-model="setClimbRateIndex">
                <option v-for="n in durationDays" :key="`${n}`" :value="n-1">{{ n }}</option>
              </select>
              <input type="number" v-model="climbRateValue">
              <button @click="setClimbRate">設定爬升率</button>
            </b-card-body>
          </b-card>

          <b-card class="mb-4">
            <b-card-title>
              設定休息時間
            </b-card-title>
            <b-card-body>
              <select v-model="setRestTimeIndex">
                <option v-for="(item, index) in setRestTimeOptions" :key="index" :value="item.value">{{ item.value }}: {{ item.text }}</option>
              </select>
              <input type="number" v-model="restTimeValue">
              <button @click="setRestTime">設定</button>
            </b-card-body>
          </b-card>

          <b-card class="mb-4">
            <b-card-title>
              刪除里程碑
            </b-card-title>
            <b-card-body>
              <select v-model="removeMilestoneIndex">
                <option v-for="(item, index) in milestoneAry" :key="`${item.name}-${index}`" :value="item.index">{{ item.index }}: {{ item.name }}</option>
              </select>
              <button @click="removeMilestone">刪除里程碑</button>
            </b-card-body>
          </b-card>

          <b-card class="mb-4">
            <b-card-title>
              刪除路段
            </b-card-title>
            <b-card-body>
              <select v-model="removeRouteIndex">
                <option v-for="(item, index) in routeAry" :key="`${item.name}-${index}`" :value="item.index">{{ item.index }}: {{ item.name }}</option>
              </select>
              <button @click="removeRoute">刪除路段</button>
            </b-card-body>
          </b-card>

          <b-card class="mb-4">
            <b-card-title>
              目前行程的儲存用資料結構（會隨著上面各種設定的變動而變動）
            </b-card-title>
            <b-card-body>
              <button @click="getSaveObject">產生儲存用資料</button>

              <pre>{{ journeyObjectForSave }}</pre>

              <button @click="saveClicked">測試儲存(會發生什麼事還未確認，請小心測試)</button>
            </b-card-body>
          </b-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import commonBusyAndErrorHandling from "@/assets/js/commonBusyAndErrorHandling";
import JourneyEditContainer from "@/components/journey/JourneyEditContainer.vue";

export default {
  mixins: [commonBusyAndErrorHandling],
  name: 'JourneyDetailEditTest',
  data() {
    return {
      id: this.$route.params.id,
      journeyObjectArray: [],
      journey: {},
      init: false,

      startTimeValue: '',
      setRestPointIndex: 0,

      setLeaveTimeIndex: 0,
      leaveTimeValue: '',

      setClimbRateIndex: 0,
      climbRateValue: '',

      setRestTimeIndex: 0,
      restTimeValue: '0',

      removeMilestoneIndex: 0,
      removeRouteIndex: 0,

      journeyObjectForSave: {},
    };
  },
  components: {
    JourneyEditContainer,
  },
  props: {
  },
  mounted() {
    this.readJourney();
  },
  computed: {
    journeyId() {
      return this.id;
    },
    setRestTimeOptions() {
      const ary = this.journeyObjectArray;
      const opts = [];
      for (let i=0;i<ary.length;i++) {
        const item = ary[i];
        if (item.type === 'milestone' && !item.isRestPoint) {
          opts.push({
            value: i,
            text: item.detailObject.name,
          });
        }
      }
      return opts;
    },
    milestoneAry() {
      return this.journeyObjectArray.map((item, index) => {
        return {
          index,
          name: item.detailObject.name,
          origin: item,
        };
      }).filter(item => item.origin.type === 'milestone');
    },
    routeAry() {
      return this.journeyObjectArray.map((item, index) => {
        return {
          index,
          name: item.detailObject.name,
          origin: item,
        };
      }).filter(item => item.origin.type === 'route');
    },
    restPointAry() {
      return this.journeyObjectArray.map((item, index) => {
        return {
          index,
          name: item.detailObject.name,
          origin: item,
        };
      }).filter(item => item.origin.type === 'milestone' && item.origin.isRestPoint);
    },
    durationDays() {
      return this.journeyObjectArray.filter(j => j.type === 'milestone' && j.isRestPoint).length + 1;
    }
  },
  methods: {
    readJourney() {
      this.handleAsyncTask(async () => {
        const j = await this.$store.dispatch('api/getJourneyDetailPromise', this.journeyId);
        this.journey = Object.assign({}, j);
        this.init = true;
      });
    },
    updateJourneyObjectArray(ary) {
      this.journeyObjectArray.splice(0);
      for (const item of ary) {
        this.journeyObjectArray.push(item);
      }
      console.log('updated', ary);
    },
    setStartTime() {
      try {
        const d = new Date(this.startTimeValue);
        this.$refs['edit-main'].setStartTimestamp(d.getTime());
      } catch (error) {
        console.error(error);
        alert(error.message);
      }
    },
    setRestTime() {
      try {
        this.$refs['edit-main'].setRestTime(parseInt(this.setRestTimeIndex), parseInt(this.restTimeValue));
      } catch (error) {
        console.error(error);
        alert(error.message);
      }
    },
    toggleRestPoint() {
      try {
        this.$refs['edit-main'].setRestPoint(parseInt(this.setRestPointIndex), !this.journeyObjectArray[parseInt(this.setRestPointIndex)].isRestPoint);
      } catch (error) {
        console.error(error);
        alert(error.message);
      }
    },
    setLeaveTime() {
      try {
        const d = new Date(this.leaveTimeValue);
        this.$refs['edit-main'].setRestPointLeaveTime(parseInt(this.setLeaveTimeIndex), d.getTime());
      } catch (error) {
        console.error(error);
        alert(error.message);
      }
    },
    removeMilestone() {
      try {
        this.$refs['edit-main'].removeMilestone(parseInt(this.removeMilestoneIndex));
      } catch (error) {
        console.error(error);
        alert(error.message);
      }
    },
    removeRoute() {
      try {
        this.$refs['edit-main'].removeRoute(parseInt(this.removeRouteIndex));
      } catch (error) {
        console.error(error);
        alert(error.message);
      }
    },
    setClimbRate() {
      try {
        this.$refs['edit-main'].setClimbRate(parseInt(this.setClimbRateIndex), parseFloat(this.climbRateValue));
      } catch (error) {
        console.error(error);
        alert(error.message);
      }
    },
    getSaveObject() {
      try {
        this.journeyObjectForSave = Object.assign({}, this.$refs['edit-main'].generateSaveFormat());
      } catch (error) {
        console.error(error);
        alert(error.message);
      }
    },
    async saveClicked() {
      try {
        if (this.journeyObjectForSave.serial) {
          await this.handleAsyncTask(async () => {
            const data = await this.$store.dispatch('api/postJourneyUpdatePromise', this.journeyObjectForSave);
            console.log(data);
            alert('儲存編輯成功！');
          });
        } else {
          alert('請先取得儲存用物件（點擊「產生儲存用資料」按鈕）');
        }
      } catch (error) {
        console.error(error);
        alert(error.message);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "src/assets/scss/basic";
.journey-detail-edit-test {
  padding: 20px;
}
</style>